import * as React from 'react'

function FranIllustration(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={292.919} height={547.365} viewBox="0 0 292.919 547.365" {...props}>
      <g data-name="Group 6310" transform="translate(-1601.231 -430.936) rotate(-158 970.925 176.965)">
        <path
          data-name="Path 2080"
          d="M93.108 0c.029.057-11.873 14.858-18.608 21.569A77.406 77.406 0 0159.3 33.6c-4.178 2.447-8.3 5.518-10.815 9.764s-3.312 13.063 1.146 16.5c4.9 3.793 12.737 3.595 18.512 3.4a178.225 178.225 0 0021.583-2.42c6.864-1.062 13.728-2.293 20.663-2.93 4.982-.467 10.685-.962 15.483.863a9.652 9.652 0 014.161 2.83 11.32 11.32 0 011.415 2.675 9.709 9.709 0 01.3 1.231c.34.991.637-3.935 0 .439a30.6 30.6 0 01-3.948 11.732c-5.8 9.624-16.389 15.568-26.324 20.054-14.464 6.524-31.037 12.737-47.1 12.638-15.271-.17-30.867-5.788-41.736-16.729A42.9 42.9 0 011.625 75.165 37.6 37.6 0 01.55 70a31 31 0 01-.311-3.241c.1 2.9.156-.793.354-2.165A48.625 48.625 0 014.2 52.28c.679-1.585-.665-4.005 0-5.562-7.443 17.465-5.221 38.708 8.493 52.482a58.026 58.026 0 0029.72 15.48c13.884 2.831 26.89.113 40.123-4.246 17.21-5.661 41.51-13.785 47.935-32.919a38.751 38.751 0 001.415-17.181c-1.33-8.308-11.039-8.492-17.705-8.237-13.006.623-25.772 3.85-38.722 5.123-7.289.722-27.669 3.241-28.7-8.053v4.897c.481-4.755 4.019-8.633 7.586-11.52 5.321-4.246 11.322-7.19 16.5-11.86A174.6 174.6 0 0093.137 5.6c.906-1.217 0-5.548 0-5.548z"
          transform="translate(0 122.522)"
          fill="#263238"
        />
        <path
          data-name="Path 2081"
          d="M77.99.63S68.666 20.521 62.068 29.3C59.1 33.322 53.01 37.795 52.43 43c-.156 1.316-.566 4.458.34 5.661 1.486 1.882 6.454 1.274 8.492 1.26 14.733-.113 29.381-2.095 44.142-1.415 8.492.4 24.06 1.217 24.98 12.568v-2.83c0 5.109-2.958 12.115-4.911 16.9a55.054 55.054 0 01-12.243 18.823 41.369 41.369 0 01-22.092 11.082c-10.912 1.826-21.753-.835-32.551-2.095-9.511-1.1-19.12-1.727-28.546-3.467-6.539-1.217-13.53-3.029-18.554-7.642S4.155 79.715 4.24 72.936c.17-12.016 2.66-24.13 3.977-36.075S10.793 12.178.277 4.1c.863.665-.934 4.84 0 5.548a21.229 21.229 0 017.076 8.492 23.058 23.058 0 011.274 5.152 16.383 16.383 0 01.156 1.854c-.1-2.151 0-.552 0 0-.113 1.7-.269 3.4-.439 5.1C6.929 44.022 4.254 57.792 4.1 71.69c-.071 8.647 0 18.243 6.454 24.895 6.921 7.19 18.229 8.492 27.6 9.737 6.793.849 13.615 1.415 20.408 2.25 7.8.906 15.568 2.647 23.479 2.831a43.208 43.208 0 0032.679-13.289c6.751-7.232 11.067-16.474 13.671-25.942 1.585-5.76 3.666-13.94 1.415-19.814-7.631-19.458-76.541-1.331-77.22-10.058v5.562c.212-1.939 2.052-3.666 3.227-5.067 2.632-3.128 5.279-6.213 7.642-9.567C69.47 24.92 80.195 0 80.195 0z"
          transform="translate(14.906 125.035)"
          fill="#eceff1"
        />
        <path
          data-name="Path 2072"
          d="M211.304 69.985l-57.262 27.57-.042.014-37.52 18.059-.028.014-2.505 1.217h-.016l-8.4 4.048h-.014l-1.486.722-5.5 2.646-.991.481-3.779 1.826-.764.354-1.666.807.2-.991 18.68-94.54 14.988-5.435 26.267-9.511.085-.042 28.107-10.176.071-.042L199.076 0l2.519 14.464h0l.1.453 3.779 21.7.014.071 4.175 23.9z"
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        />
        <path
          data-name="Line 256"
          transform="translate(110.21 32.212)"
          fill="#fff"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M0 0L101.093 37.774"
        />
        <path
          data-name="Line 257"
          transform="translate(91.332)"
          fill="#eceff1"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M107.745 0L0 127.742"
        />
      </g>
      <path
        data-name="Path 17172"
        d="M1679.785 598.929c45.189-42.9 138.6-24.954 162.986 28.9 24.412 53.917 15.07 142.062-119.614 148.866s-159.315 65.873-63.316 91.532 196.441 41.116 163.477 109.858"
        fill="none"
        stroke="#263238"
        strokeLinejoin="round"
        strokeWidth={1}
        opacity={0.3}
        transform="translate(-1601.231 -430.936)"
      />
    </svg>
  )
}

export default FranIllustration
